import { Link } from "react-router-dom";

const QUIET_LINKS = [
  { to: "/treatments", label: "Treatments" },
  { to: "/concerns", label: "Concerns" },
  { to: "/contact", label: "Contact" },
];

const NotFound = () => (
  <section className="min-h-[80vh] flex items-center justify-center bg-cream pt-24" data-testid="not-found-page">
    <div className="text-center px-8 py-20 relative max-w-xl">
      <p className="eyebrow mb-6">Page not found</p>
      <h1 className="text-deep-sea">This page has drifted</h1>
      <p className="text-ink/70 text-sm mt-6 leading-relaxed">
        The page you're looking for isn't here — but the practice is, and it's the quieter place anyway.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="btn-ghost-sea inline-flex items-center mt-10 px-8 py-4 text-sm font-medium tracking-[0.06em]"
      >
        Return home
      </Link>
      <div className="flex items-center justify-center gap-7 mt-9" data-testid="not-found-quiet-links">
        {QUIET_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`not-found-link-${l.label.toLowerCase()}`}
            className="text-soft-grey hover:text-gold text-[11px] tracking-[0.18em] uppercase transition-colors duration-300"
          >
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default NotFound;
